import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const EmptyState: React.FC<{ title: string; description?: string; icon?: React.ReactNode }> = ({ title, description, icon }) => (
  <Box textAlign="center" py={8} color="text.secondary">
    {icon ?? <SearchOffIcon sx={{ fontSize: 48, opacity: 0.5, mb: 1 }} />}
    <Typography fontWeight={700} color="text.primary" mb={0.5}>{title}</Typography>
    {description && <Typography fontSize={14}>{description}</Typography>}
  </Box>
);

export default EmptyState;
